import { initSentry } from "@/sentry";
import { I18n } from "@/i18n/i18n";

initSentry();

// bootstrap
import { Alert, Button, Collapse, Dropdown, Modal, Popover, Tab, Tooltip } from "bootstrap";
window.bootstrap = { Alert, Button, Collapse, Dropdown, Modal, Popover, Tab, Tooltip };

import { initTooltips, setHTMLExecuteScripts, katexOptions } from "@/utilities";
import { themeState } from "@/state/Theme";

// Use a global dodona object to prevent polluting the global na
const dodona = window.dodona || {};
window.dodona = dodona;
dodona.I18n = I18n;
dodona.initTooltips = initTooltips;
dodona.katexOptions = katexOptions;
dodona.initTheme = (theme) => themeState.initTheme(theme);
dodona.setHTMLExecuteScripts = setHTMLExecuteScripts;

dodona.ready.then(initTooltips);
